import React from 'react';
import {useSelector} from 'react-redux';
import {noop} from 'lodash';

import AcceptByComponent from '/component/partial/report/AcceptByComponent/AcceptByComponent';
import CandidateDisposition from '/component/partial/report/CandidateDisposition';
import {CandidateReportAcceptByIconComponent} from '/component/partial/report/CandidateReportAcceptByIconComponent/CandidateReportAcceptByIconComponent';
import CandidatesListHeader from '/component/partial/report/CandidatesListHeader/CandidatesListHeader';
import DateAddedComponent from '/component/partial/report/DateAddedComponent';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import PersonFullName from '/component/partial/report/PersonFullName';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';
import {CANDIDATE_PROFILE} from '/enum/popover.enum';
import {SCREEN_NAMES} from '/enum/tealium.enum';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';
interface AllCandidatesContentProps {
  loadingData: {
    total?: number;
  };
  recordsShowRecord: (params: {recordType: string; recordId: string}) => void;
  allReportData: any;
}

export const AllCandidatesContent = ({
  loadingData = {},
  recordsShowRecord = noop,
}: AllCandidatesContentProps) => {
  const {ff_accept_decline = ''} = useSelector(variablesFeatureFlag);

  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  const recordsName = reportPayload.reportName;

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      hideAvatar={true}
      dataRendererProps={{
        listHeaderComponent: CandidatesListHeader,
        personNameComponent: PersonFullName,
        personRoleComponent: DateAddedComponent,
        CandidateDispositionInfo: CandidateDisposition,
        AcceptByComponent: shouldReleaseFeature(ff_accept_decline)
          ? AcceptByComponent
          : undefined,
        AcceptByIconComponent: shouldReleaseFeature(ff_accept_decline)
          ? CandidateReportAcceptByIconComponent
          : undefined,
        isCandidateReport: true,
        onRecordPress: (reportData: {prospectInfoId: string}) => {
          recordsShowRecord({
            recordType: CANDIDATE_PROFILE,
            recordId: reportData.prospectInfoId,
          });
        },
        alternateItemKey: 'prospectInfoId',
      }}
      reportName={recordsName}
      loadingData={loadingData}
      currentScreenName={SCREEN_NAMES.clientsToContact}
      reportParams={[{...sortParam.params}]}
    />
  );
};
